import 'date-fns';
import React, {useContext, useEffect} from 'react';
import Grid from '@material-ui/core/Grid';
import {CurrentItemType} from './Cards';
import {CartContext} from "./MainPage";
import {Cookies} from "react-cookie";


import {Button, TextField} from "@material-ui/core";

function isValidDate(date) {
    return date && Object.prototype.toString.call(date) === "[object Date]" && !isNaN(date);
}

function dateToString(date) {
    if (isValidDate(date)) {
        let year = date.getFullYear();
        let month = date.getMonth() + 1;
        let day = date.getDate();
        return year + "-" + (month < 10 ? "0" : "") + month + "-" + (day < 10 ? "0" : "") + day;
    }
}

export default function QuantitySelector(props) {
    // The first commit of Material-UI
    const currentItem = useContext(CurrentItemType);
    const oldCart = useContext(CartContext);

    const windowUrl = window.location.search;
    const params = new URLSearchParams(windowUrl)
    const currency = params.get('currency');

    const [price, setPrice] = React.useState(props.prices[props.duration - 1]);
    const [itemNum, setNum] = React.useState(1);

    const cookies = new Cookies();


    return (
        <Grid container spacing={1} style={{width: "100%"}}>
            <Grid item xs={12} sm={6}>
                <TextField
                    value={itemNum}
                    type="number"
                    id="Qt"
                    label="Quantity"
                    required={true}
                    InputLabelProps={{shrink: true}}
                    onChange={(event) => {
                        if (event.target.value == "") {
                            setNum(" ");
                        } else if (event.target.value > 10) {
                            setNum(10)
                            setPrice(10 * props.prices[props.duration - 1]);
                        } else {
                            setNum(Number.parseInt(event.target.value))
                            setPrice(event.target.value * props.prices[props.duration - 1]);
                        }

                    }}
                    onBlur={(event) => {
                        if (event.target.value == "" || event.target.value < 1) {
                            event.target.value = 1;
                            setNum(1);
                        }
                    }}
                ></TextField>
            </Grid>

            <Grid item xs={12} sm={3}>
                <h4>Price: {currency + " " + price}</h4>
            </Grid>
            <Grid item xs={12} sm={6}>
                <Button
                    variant="contained"
                    color="primary"
                    onClick={() => {
                        if (isValidDate(new Date(props.start)) && isValidDate(new Date(props.end))) {
                            let newCart = [];
                            newCart = oldCart.cart;
                            for (let index = 0; index < newCart.length; index++) {
                                let item = newCart[index];
                                if (item.itemName == currentItem.currentItemName && item.itemType === currentItem.currentItemType) {
                                    newCart[index].itemNum += itemNum;
                                    oldCart.setCart(newCart);
                                    cookies.set("cart", newCart, {maxAge: 60 * 60})
                                    cookies.set("cartNum", parseInt(oldCart.cartNum) + parseInt(itemNum), {maxAge: 60 * 60})
                                    oldCart.setCartNum(parseInt(oldCart.cartNum) + parseInt(itemNum));
                                    props.close();
                                    return
                                }
                            }
                            newCart.push({
                                itemName: currentItem.currentItemName,
                                itemNo: currentItem.currentItemNo,
                                itemType: currentItem.currentItemType,
                                startDate: dateToString(new Date(props.start)),
                                endDate: dateToString(new Date(props.end)),
                                duration: props.duration,
                                price: price / itemNum,
                                itemNum: itemNum
                            });
                            console.log(newCart);
                            oldCart.setCart(newCart);
                            cookies.set("cart", newCart, {maxAge: 60 * 60})
                            cookies.set("cartNum", parseInt(oldCart.cartNum) + parseInt(itemNum), {maxAge: 60 * 60})
                            oldCart.setCartNum(parseInt(oldCart.cartNum) + parseInt(itemNum));
                            props.close();
                        }
                        return
                    }}> Add to cart </Button>
            </Grid>
            <Grid item xs={6} sm={6}>
                <Button
                    variant="contained"
                    color="secondary"
                    onClick={props.close}> Close </Button>
            </Grid>
        </Grid>
    );
}